import { GET_RECOMMENDATION, FETCHING_RECOMMENDATION, SUBMIT_RECOMMENDATION, LOAD_RECOMMENDATION, RESET_RECOMMENDATION, SET_ERROR, RESET_ERROR } from '../reducers/recommendations';
import { msalConfig, tokenRequest, observationUrl } from '../config-client';
import { callApiWithB2CToken } from '../actions/callApi';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// get the recommendation for a particular patient
export const getRec = (code, subject, performer) => {
  // please pass in the observation code, the subject (which is the patient id) and the performer (the clinician id)
  // code is either "followUp" or "Detailed"
  const url = observationUrl + `?code=${code}&subject=Patient/${subject}&performer=Practitioner/${performer}`;
  return (dispatch) => {
    dispatch({ type: FETCHING_RECOMMENDATION });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then((response) => {
          // if the response is an error then send an error message as the payload
          if (response.status !== 200 && response.status !== 201) {
            dispatch({ type: SET_ERROR, payload: '' });
          } else {
            dispatch({ type: SET_ERROR, payload: 'no error' });
          }
          return response.json();
        }))
      .then((json) => {
        dispatch({ type: GET_RECOMMENDATION, payload: json.entry[0], recommendation: code });
      })
      .catch(error => dispatch({ type: GET_RECOMMENDATION, payload: error }));
  };
};


// submit the new or edited recommendations objects
// just like any POST/PUT request, the server determines whether it actually is a post or put request ...
// by checking if an id exists in the body's object
export const submitRec = (responseObject, code) => {
  const url = observationUrl;
  const body = JSON.stringify(responseObject);
  return (dispatch) => {
    dispatch({ type: SUBMIT_RECOMMENDATION });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'POST', body)
        .then((response) => {
          // if the response is an error then send an error message as the payload
          if (response.status !== 200 && response.status !== 201) {
            dispatch({ type: SET_ERROR, payload: '' });
          } else {
            dispatch({ type: SET_ERROR, payload: 'no error' });
          }
          return response.json();
        }))
      .then((json) => {
        dispatch({ type: SUBMIT_RECOMMENDATION, payload: json, recommendation: code });
      })
      .catch(error => dispatch({ type: SUBMIT_RECOMMENDATION, payload: error }));
  };
};

// loading the form object to repopulate the form fields for recommendations
export const loadRec = responseObject => (dispatch) => {
  dispatch({
    type: LOAD_RECOMMENDATION,
    payload: responseObject,
  });
};

// reset the reducer for recommendations
export const resetRec = () => (dispatch) => {
  dispatch({
    type: RESET_RECOMMENDATION,
    payload: null,
  });
};

// reset the error message once the page is reloaded
export const resetRecError = () => (dispatch) => {
  dispatch({
    type: RESET_ERROR,
    payload: null,
  });
};



// WEBPACK FOOTER //
// ./src/actions/recommendations.js